import { PdfPaperSize } from 'components/ExportModal/Types'
import { RadioButton } from './RadioButton'
import { RadioButtonsProps } from './Types'
import Styles from './RadioButton.module.scss'

const paperSizeDimensions = {
  [PdfPaperSize.Letter]: '8.5 x 11 inches',
  [PdfPaperSize.Legal]: '8.5 x 14 inches',
  [PdfPaperSize.Tabloid]: '8.5 x 17 inches',
  [PdfPaperSize.A4]: '21 x 29.7 cm',
}

export const RadioButtons = <T extends string>({
  options,
  onSelectionChange,
  selectedKey,
  isDisabled = false,
  showBullets = true,
  classOverrides,
  variant,
}: RadioButtonsProps<T>) => {
  return (
    <>
      {options.map((option) => (
        <div className={Styles.radioContainer} key={option.key + 'container'}>
          <RadioButton
            key={option.key}
            isDisabled={isDisabled || option.isDisabled}
            onPress={() => selectedKey !== option.key && onSelectionChange(option.key)}
            option={option}
            selected={selectedKey === option.key}
            showBullet={showBullets}
            classOverrides={classOverrides}
            variant={variant}
          />
          <div className={Styles.paperSize}>{paperSizeDimensions[option.key as PdfPaperSize]}</div>
        </div>
      ))}
    </>
  )
}
